import React, { useEffect, useState, useMemo } from 'react';
import { Map, GoogleApiWrapper, Polygon } from 'google-maps-react';
import config from '../../../constants/config';
import '../../../../assets/scss/fieldmap.scss';

const FieldMapDetail = props => {
  const { fieldListById, shapeRefId, location, properties, mapHeight = '430px', newWorkedPoints } = props;

  const mapStyles = useMemo(() => ({
    position: 'absolute',
    inset: '0px',
    width: '100%',
    height: mapHeight,
    display: 'inherit',
    overflow: 'hidden',
    marginLeft: '5px',
  }), [mapHeight]);

  const staticOptions = useMemo(() => ({
    fillColor: "#baf5d593",
    fillOpacity: 1,
    strokeColor: "#ffff",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    mapTypeId: 'satellite',
    zIndex: 3,
  }), []);

  const workedArea = useMemo(() => ({
    fillColor: "#ffff00",
    fillOpacity: 1,
    strokeColor: "#ffff",
    strokeOpacity: 1,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    mapTypeId: 'satellite',
    zIndex: 3,
  }), []);

  const options = properties ? properties : fieldListById && fieldListById[shapeRefId] ? fieldListById[shapeRefId].properties : null;
    const paths = location ? location : fieldListById && fieldListById[shapeRefId] ? fieldListById[shapeRefId].location : [];
const newWorkedPath = props.newWorkedPoints;  
  const [map/* , setMap */] = useState(props.google.maps);
  const [mapBounds, setMapBounds] = useState(new props.google.maps.LatLngBounds());

  const calculateBounds = (locations) => {
    const bounds = new props.google.maps.LatLngBounds();
    locations.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
    return bounds;
  };

  useEffect(() => {
    if (props.loaded && map && paths.length) {
      const bounds = calculateBounds(paths);
      setMapBounds(bounds);
    }
  }, [props.loaded, map, paths]);

  if (!paths.length) return null;

  return (
    <div>
      <Map
        mapType='satellite'
        google={props.google}
        zoom={4}
        option={staticOptions}
        style={mapStyles}
        mapTypeControl={false}
        streetViewControl={false}
        zoomControl={true}
        initialCenter={paths[0]}
        bounds={mapBounds}
      >
        <Polygon paths={paths} options={options} />
        {newWorkedPath && (
          <Polygon paths={newWorkedPoints} options={workedArea} />
        )}
      </Map>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: config.common.MAP_API_KEY,
  libraries: ['drawing'],
})(FieldMapDetail);
